// @flow
import * as React from 'react';
import LocationInputContainer from 'containers/LocationInputContainer';
import Field from './Field';

const LocationField = ({
  name,
  label,
  description,
  disabled,
  includeCity,
  includeFull,
  placeholder,
  customErrorMatch,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  disabled?: boolean,
  includeCity?: boolean,
  includeFull?: boolean,
  placeholder?: string,
  'data-qa-id'?: string,
  customErrorMatch?: APIErrors => Object
}) => (
  <Field
    customErrorMatch={customErrorMatch}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      let locationText;
      if (value && typeof value === 'object') {
        if (value.text) {
          locationText = value.text;
        }

        // @TODO: possible to use just `full` or `text` on the client?
        if (value.full && includeFull) {
          locationText = value.full;
        }
      }

      return (
        <LocationInputContainer
          id={id}
          name={name}
          locationText={locationText}
          hasError={hasError}
          data-qa-id={props['data-qa-id'] || qaId}
          onChange={location => updateValue(location)}
          disabled={disabled}
          showClearButton
          includeCity={includeCity}
          includeFull={includeFull}
          placeholder={placeholder}
        />
      );
    }}
  />
);

export default LocationField;
